import React, { useEffect, useRef, useState } from 'react';
import { Box, Typography, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { vendorApi } from '../../api/api';

const AdvertisementPage = ({ setShowAd }) => {
  const [ads, setAds] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [timeLeft, setTimeLeft] = useState(0);
  const intervalRef = useRef(null);

  useEffect(() => {
    const fetchAds = async () => {
      try {
        const response = await vendorApi.getAllAdvertisement();
        if (response.data.success) {
          setAds(response.data.data);
        } else {
          console.error('Failed to load ads');
        }
      } catch (err) {
        console.error('API Error:', err);
      }
    };
    fetchAds();
  }, []);

  // Set initial time when ads load
  useEffect(() => {
    if (ads.length > 0) {
      setTimeLeft(ads[currentIndex]?.duration_seconds || 5);
    }
  }, [ads, currentIndex]);

  // Countdown logic
  useEffect(() => {
    if (ads.length === 0 || timeLeft <= 0) return;

    intervalRef.current = setInterval(() => {
      setTimeLeft((prev) => {
        if (prev <= 1) {
          clearInterval(intervalRef.current);
          // Move to next ad
          setCurrentIndex((prevIndex) => (prevIndex + 1) % ads.length);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(intervalRef.current);
  }, [timeLeft, ads.length]);

  if (ads.length === 0) {
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '300px', 
        width: '100%',
      }}
    >
      {/* <Typography variant="h6" color="textSecondary">
        No advertisements...
      </Typography> */}
    </Box>
  );
}


  const currentAd = ads[currentIndex];
  const mediaUrl = currentAd.file_path || '';
  const isVideo = currentAd.file_type?.startsWith('video/') || /\.(mp4|mov|avi|webm)$/i.test(mediaUrl);
  const isImage = currentAd.file_type?.startsWith('image/') || /\.(jpg|jpeg|png|gif|webp)$/i.test(mediaUrl);

  return (
    <Box
      sx={{
        position: 'sticky',
        top: '180px',
        backgroundColor: 'rgb(211, 208, 208)',
        height: '65vh',
        paddingBottom: 2,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
      }}
    >
      <IconButton
        aria-label="close"
        onClick={() => setShowAd(false)}
        sx={{
          position: 'absolute',
          top: 8,
          right: 8,
          color: '#fff',
          backgroundColor: 'rgba(0,0,0,0.5)',
          '&:hover': {
            backgroundColor: 'rgba(0,0,0,0.7)',
          },
          zIndex: 10,
        }}
      >
        <CloseIcon />
      </IconButton>

      <Box
        sx={{
          width: '100%',
          flexGrow: 1,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          position: 'relative',
          overflow: 'hidden',
          bgcolor: '#000',
          borderRadius: 2,
          padding: '5px',
        }}
      >
        {mediaUrl && (isVideo || isImage) ? (
          <Box
            onClick={() => {
              if (currentAd.target_url) {
                window.open(currentAd.target_url, '_blank', 'noopener,noreferrer');
              }
            }}
            sx={{ cursor: currentAd.target_url ? 'pointer' : 'default' }}
          >
            {isVideo ? (
              <video
                key={currentAd.id}
                src={mediaUrl}
                autoPlay
                muted
                loop
                playsInline
                style={{ maxHeight: '100%', maxWidth: '100%', borderRadius: 8 }}
              />
            ) : (
              <img
                key={currentAd.id}
                src={mediaUrl}
                alt={currentAd.title || 'Advertisement'}
                style={{ maxHeight: '100%', maxWidth: '100%', borderRadius: 8 }}
              />
            )}
          </Box>
        ) : (
          <Typography
            sx={{ color: '#fff', textAlign: 'center', px: 2 }}
            variant="body1"
          >
            No valid media available for this ad
          </Typography>
        )}
      </Box>

      <Box sx={{ mt: 1, textAlign: 'center', color: '#333' }}>
        <Typography variant="h6">{currentAd.title || 'Untitled Ad'}</Typography>
        <Typography variant="caption" color="textSecondary">
          Time left: {timeLeft} second{timeLeft !== 1 ? 's' : ''}
        </Typography>
      </Box>
    </Box>
  );
};

export default AdvertisementPage;
